import orderService from "@/services/order.service";
import {
  PagePedidoInput,
} from "@/models/pedido";
import GlobalStore from "@/store/modules/global";
import { router } from "@/router";


const initialStatePaginateInput: any = {
  type_id: null,
  type_key: null,
  company_id: null,
  group: null,
  status: null,
  plate: null,
  payment_status: null,
  inspection_status: null,
  inspection_created_at: null,
  created_at: null,
  expiring_in: null,
  validity_expired: null,
  valid_until: null
}

export const order = {
  namespaced: true,

  state: {
    table: {
      header: [
        {
          text: "Número",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Grupo",
          align: "start",
          sortable: false,
          value: "group",
        },
        {
          text: "Veículo",
          align: "start",
          sortable: false,
          value: "plate",
        },
        {
          text: "Tipo",
          align: "start",
          sortable: false,
          value: "type_solicitation.name",
        },
        {
          text: "Status",
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: "Vencimento",
          align: "start",
          sortable: false,
          value: "valid_until",
        },
        {
          text: "Data do pedido",
          align: "start",
          sortable: false,
          value: "created_at",
        },
        {
          text: "Expiração",
          align: "start",
          sortable: false,
          value: "expiration",
        },
        {
          text: "Ações",
          align: "start",
          sortable: false,
          value: "actions",
        },
      ],
      content: [] as Array<any>,
      paginate: {
        input: {
          ...initialStatePaginateInput
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: 'id:desc'
        },
      },
      isLoading: false,
      total: 0,
    },

    detail: {
      data: null as any,
      isLoading: true,
    },
  },

  mutations: {
    setTableIsLoading(state: any, value: boolean): void {
      state.table.isLoading = value;
    },

    setTableContent(state: any, value: any[]): void {
      state.table.content = value;
    },

    setTableTotal(state: any, value: number): void {
      state.table.total = value;
    },

    setTablePaginate(state: any, value: PagePedidoInput): void {
      state.table.paginate = value;
    },

    setDetail(state: any, value: any): void {
      state.detail.data = value;
    },

    setDetailIsLoading(state: any, value: boolean): void {
      state.detail.isLoading = value;
    },
  },

  actions: {
    SEARCH({ commit, dispatch, state }: any): void {
      commit("setTableIsLoading", true);
      orderService.list(state.table.paginate).subscribe(
        ({ items, totalItems }) => {
          commit("setTableContent", items);
          commit("setTableTotal", totalItems);
          commit("setTableIsLoading", false);
        },
        (error) => {
          commit("setTableIsLoading", false);
        }
      );
    },

    CHANGE_PAGE({ commit, dispatch, state }: any, value: PagePedidoInput): void {
      commit("setTablePaginate", value);
    },

    CLEAR({ commit }: any): void {
      commit("setTableContent", []);
      commit("setTableTotal", 0);
      commit("setTableIsLoading", false);
      commit("setTablePaginate", {
        input: {
          ...initialStatePaginateInput
        },
        inputPage: {
          page: 1,
          per_page: 10,
          sort: "id:desc"
        },
      });
    },

    SHOW({ commit, dispatch, state }: any, value: number): void {
      commit("setDetailIsLoading", true);
      orderService.show(value).subscribe(
        (res) => {
          commit("setDetail", res);
          commit("setDetailIsLoading", false);
        },
        () => {
          commit("setDetailIsLoading", false);
          GlobalStore.setSnackBar({
            show: true,
            type: "error",
            message: "Pedido não encontrado",
          });
          router.push({ name: "dashboard-pedidos-list" });
        }
      );
    },

    SHOW_PUBLIC({ commit, dispatch, state }: any, value: string): void {
      commit("setDetailIsLoading", true);
      orderService.showPublic(value).subscribe(
        (res) => {
          commit("setDetail", res);
          commit("setDetailIsLoading", false);
        },
        () => {
          commit("setDetailIsLoading", false);
          GlobalStore.setSnackBar({
            show: true,
            type: "error",
            message: "Pedido não encontrado",
          });
          router.push({ name: "dashboard-pedidos-list" });
        }
      );
    },

    CLEAR_DETAIL({ commit, dispatch, state }: any): void {
      commit("setDetail", null);
      commit("setDetailIsLoading", false);
    },
  },
};

